<template>
  <div
    class="title-center-container"
    :class="device.isMobile ? 'title-center-container-mobile' : ''"
    :id="content.key"
  >
    <span
      class="title-text"
      :id="`${content.key}-1`"
      :style="{
        position: 'relative',
        display: 'inline-block',
        fontFamily: content.textStyle.fontFamily || '',
        fontSize: content.textStyle.fontSize + 'rem' || '',
        minHeight: content.textStyle.height + 'rem' || '',
        lineHeight: content.textStyle.lineHeight + 'rem' || '',
        maxWidth: content.textStyle.maxWidth + 'rem' || '',
        textIndent:
          content.textStyle.textIndent &&
          typeof content.textStyle.textIndent === 'string'
            ? content.textStyle.textIndent
            : content.textStyle.textIndent &&
              typeof content.textStyle.textIndent === 'number'
            ? content.textStyle.textIndent + 'rem'
            : '',
        fontWeight: content.textStyle.fontWeight || '',
        textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.textStyle.textAlign || '',
        color: content.textStyle.color || '',
        backgroundColor: content.textStyle.backgroundColor || '',
        backgroundImage: content.textStyle.backgroundImage
          ? `url(${content.textStyle.backgroundImage})`
          : '',
        borderRadius: content.textStyle.borderRadius
          ? content.textStyle.borderRadius.borderTopLeftRadius +
            'rem' +
            ' ' +
            (content.textStyle.borderRadius.borderTopRightRadius + 'rem') +
            ' ' +
            (content.textStyle.borderRadius.borderBottomRightRadius + 'rem') +
            ' ' +
            (content.textStyle.borderRadius.borderBottomLeftRadius + 'rem')
          : '',
        padding: content.titleImageType == 3 ? '10rem 12rem' : content.titleImageType == 4 ? '0 37rem 0 18rem' : '',
        margin: content.textStyle.margin + 'rem' || '',
        marginTop: content.textStyle.marginTop + 'rem' || '',
        marginBottom: content.textStyle.marginBottom + 'rem' || '',
        border: content.textStyle.border || '',
      }"
    >
      <span
        v-if="content.shortText"
        :id="`${content.key}-1-1`"
        v-html="content.shortText"
      ></span>
      <span
        :id="`${content.key}-1-2`"
        v-html="content.text"
        :class="content.titleImageType == 2 ? 'active' : ''"
      ></span>
      <img
        v-if="content.titleImage && content.titleImageType == 1"
        :src="content.titleImage"
        alt=""
        :style="{
          width: '80rem',
          height: content.textStyle.height + 'rem' || '',
          position: 'absolute',
          top: 0,
          right: '-80rem',
        }"
      />
    </span>
</div>
</template>
  <script>
/*
  标题 - 英语标题
  */
export default {
  name: "title-english",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.title-center-container{
  position: relative;
  z-index: 5;
}
.active {
  padding: 0 40rem 0 0;
}
.active::before {
  content: "";
  display: inline-block;
  width: 28rem;
  height: 28rem;
  background: url(~@/assets/images/books/book2/title-icon2.png) no-repeat;
  background-size: cover;
  top: 3rem;
  right: 10rem;
  position: relative;
}
.title-text{
  margin-top: 20rem;
}
//   .title-center-container{
//     margin-top: 20rem;
//     width: 100%;
//     background-position: center;
//     background-repeat: no-repeat;
//     background-size: cover;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-size: 20rem;
//     color: #333;
//     font-weight: bold;
//     text-indent: 0;

//     .title-text{
//       text-align: center;
//       display: block;
//     }
//   }
//   .title-center-container-mobile{
//     margin-top: 50rem;
//     margin-bottom: 28rem;
//     font-size: 32rem;
//     line-height: 52rem;
//   }
</style>